import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { Box, Flex } from '@chakra-ui/react'
import { AiFillCheckCircle } from 'react-icons/ai'
import { resetUpdatePdsrOutcome, updatePdsr } from '../../actions/dsr-actions'
import PageLoader from '../../../global/components/helper-components/components/PageLoader'
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton'
import LaunchdeckModal from '../../../global/components/helper-components/components/LaunchdeckModal'



function ProspectDsrPublishCardModal({
  modalTransferPayload,
  handleCloseModal,
  updatePdsr,
  resetUpdatePdsrOutcome,
  updateProspectDsrOutcome
}) {

  const { pDsrId, dsrTitle } = modalTransferPayload || {}
  // UX Management
  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {
    if (updateProspectDsrOutcome) {
      const { updatePdsrStatus } = updateProspectDsrOutcome || {};

      if (updatePdsrStatus) {
        setShowLoader(false)
        resetUpdatePdsrOutcome()
        handleCloseModal()
      }
    }
  }, [updateProspectDsrOutcome]);

  const handleClickPublishButton = () => {
    setShowLoader(true);

    updatePdsr({
      pDsrId,
      // firstPublish: true, // Used to help guide backend to create instances in tables upon publishing a PDSR
      sourceEvent: "re-publish-prospector-dsr-card",
      status: 'active'
    })
  }

  function displayContent() {
    if (showLoader) {
      return (
        <Box w="100%" align="center" >
          <Box px='1em'>
            <PageLoader />
          </Box>
        </Box>
      )
    }

    if (!showLoader) {
      return (
        <Box w='100%' p='1em 1.8em'>
          <Flex w="100%" fontSize='0.875em' color='brandDark.500'>
            Make it publicly available again?
          </Flex>

          <Flex mt='1.625em' w='100%' justify={['center', 'flex-end']}>
            <LaunchdeckButton bg='brand.500' w={['100%', 'auto']} color='gray.50' fontSize='0.8em' py='0.4em' onClick={() => handleClickPublishButton()} label='Yes, publish' />
          </Flex>
        </Box>
      )
    }
  }

  return (
    <LaunchdeckModal
      title={
        <Flex align='center' gap='0.5em'>
          <Box as={AiFillCheckCircle} color='brand.500'
            boxSize="1.6em" />
          <Box py='0.5em' color='white'>You are about to publish <i>{dsrTitle || "this Prospector Room"}</i> again</Box>
        </Flex>
      }
      handleCloseModal={() => handleCloseModal()}
      showModal={true}
      maxW='35em'
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}

function mapStateToProps(state) {
  return {
    updateProspectDsrOutcome: state.updateProspectDsrOutcome.results.data
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updatePdsr,
      resetUpdatePdsrOutcome
    },
    dispatch,
  )


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProspectDsrPublishCardModal));
